<div class="row tabs-cont hide-nav-link" #tabsCont>
    <div class="col-md-12 h-100">
        <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
            <ngb-tab title="Pregled" id="tbList" [disabled]="tabsContainerService.IsListTabDisabled">
                <ng-template ngbTabContent>
                    <yt-fw-default-list-tabs [CondensedTable]="true"></yt-fw-default-list-tabs>
                </ng-template>
            </ngb-tab>
            <ngb-tab title="Izmena" id="tbUpdate" [disabled]="tabsContainerService.IsUpdateTabDisabled">
                <ng-template ngbTabContent>
                    <div class="row">
                        <div class="col-md-12">
                            <yt-osoba-tab-update #baseTabsUpdate></yt-osoba-tab-update>
                        </div>
                    </div>
                </ng-template>
            </ngb-tab>
        </ngb-tabset>
    </div>
</div>